import styled from "styled-components";
import { Header, ModalContent } from "../Modal/styled";
import { WhiteContainer } from "./styled";

// CustomModalContainer can be passed as Container prop to Modal component
// if we want to set a custom template for Modal container instead of the default one
export const CustomModalContainer = styled(WhiteContainer)`
  width: 80%;
  max-width: 975px;
  height: 75%;
  max-height: 767px;
  position: relative;

  overflow: hidden;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);

  > div {
    width: 100%;
    > ${ModalContent} {
      width: 100%;
      height: 100%;

      margin-right: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;

      > div {
        width: 100%;
        height: 100%;
      }
    }
  }

  ${Header} {
    position: absolute;
    justify-content: flex-end;
    z-index: 100;
  }
`;
